<template>
  <MainNavbar class="home_one" />
  <ResponsiveNavbar class="home_one" />
  <MainBanner />
  <WhyChoiceForYou />
  <FeaturesContent />
  <Anniversary />
  <HowItWorks />
  <WhatOurCustomerSays />
  <WhatOurCustomerSaysTwo />
  <FrequentlyAskedQuestions />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import ResponsiveNavbar from "../components/Layouts/ResponsiveNavbar.vue";
import MainBanner from "../components/HomeOne/MainBanner.vue";
import WhyChoiceForYou from "../components/HomeOne/WhyChoiceForYou.vue";
import FeaturesContent from "../components/HomeOne/FeaturesContent.vue";
import Anniversary from "../components/HomeOne/Anniversary.vue";
import HowItWorks from "../components/HomeOne/HowItWorks.vue";
import WhatOurCustomerSays from "../components/HomeOne/WhatOurCustomerSays.vue";
import WhatOurCustomerSaysTwo from "../components/HomeOne/WhatOurCustomerSaysTwo.vue";
import FrequentlyAskedQuestions from "../components/HomeOne/FrequentlyAskedQuestions.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "HomeOnePage",
  components: {
    MainNavbar,
    ResponsiveNavbar,
    MainBanner,
    WhyChoiceForYou,
    FeaturesContent,
    Anniversary,
    HowItWorks,
    WhatOurCustomerSays,
    WhatOurCustomerSaysTwo,
    FrequentlyAskedQuestions,
    DownloadTheApp,
    MainFooter,
  },
});
</script>